import { useMemo } from 'react';

import { fillUniqueUrls } from './fill-unique-urls';

export interface UseUniqueUrlsOptions {
    needToModify?: boolean;
}

/**
 * @description Хук используется для того, чтобы в мобильном Safari не терялся цвет или любой другой параметр, который
 * задаётся с помощью url ссылки на идентификатор в defs. Для каждого такого идентификатора, генерирует новый идентификатор,
 * чтобы не было повторений
 */
export function useUniqueUrls(svgHtml: string, { needToModify = true }: UseUniqueUrlsOptions = {}): string {
    return useMemo(() => {
        if (!needToModify) {
            return svgHtml;
        }
        return fillUniqueUrls(svgHtml);
    }, [svgHtml, needToModify]);
}
